"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var CartList_1 = __importDefault(require("../../Components/CartList"));
var Tracker_1 = __importDefault(require("../../Utils/Tracker"));
var NavUrl_1 = __importStar(require("../../Utils/NavUrl"));
var CheckoutPageWrapper_1 = __importDefault(require("../../Components/CheckoutPageWrapper"));
var CheckoutSummary_1 = __importDefault(require("../../Components/CheckoutSummary"));
function CartPage(props) {
  var renderCartEmpty = props.renderCartEmpty,
    _a = props.stickyTop,
    clientStickyTop = _a === void 0 ? null : _a,
    _b = props.renderCustomComponent,
    renderCustomComponent = _b === void 0 ? null : _b,
    _c = props.cartItemCustomRenderer,
    cartItemCustomRenderer = _c === void 0 ? null : _c,
    _d = props.cartListCustomRenderer,
    cartListCustomRenderer = _d === void 0 ? null : _d,
    _e = props.checkoutSummaryProps,
    checkoutSummaryProps = _e === void 0 ? {} : _e,
    _f = props.pageContext.pageId,
    pageId = _f === void 0 ? 'rev-CartPage' : _f;
  var cart = reconnect_js_1.useOutlet('cart')[0];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var user = reconnect_js_1.useOutlet('user')[0];
  var _g = antd_1.Modal.useModal(),
    modal = _g[0],
    contextHolder = _g[1];
  var _h = react_1.default.useState(clientStickyTop),
    stickyTop = _h[0],
    setStickyTop = _h[1];
  var sideElemRef = react_1.default.useRef(null);
  react_1.default.useLayoutEffect(function () {
    if (sideElemRef.current && clientStickyTop === null) {
      var top_1 = sideElemRef.current.getBoundingClientRect().top;
      console.log('get stickyTop', top_1);
      setStickyTop(top_1);
    }
  }, [clientStickyTop]);
  react_1.default.useLayoutEffect(function () {
    if (cart.items.length === 0) {
      return;
    }
    Tracker_1.default.viewCart({
      cart: cart
    });
  }, [cart]);
  return react_1.default.createElement(Wrapper, {
    id: pageId,
    stickyTop: stickyTop
  }, react_1.default.createElement("div", {
    className: "container"
  }, react_1.default.createElement("div", {
    className: "main"
  }, cart.items.length === 0 && (!!renderCartEmpty ? renderCartEmpty() : react_1.default.createElement("div", null, react_1.default.createElement("h3", {
    style: {
      margin: '10px 0'
    }
  }, AppActions.L('cart_empty_title')), react_1.default.createElement(antd_1.Button, {
    id: "go-to-buy",
    onClick: function onClick() {
      return AppActions.navigate(NavUrl_1.default.from(NavUrl_1.PredefinedRoute.products));
    }
  }, AppActions.L('shopping')))), cart.items.length > 0 && react_1.default.createElement(CartList_1.default, {
    cartItems: cart.items,
    renderCustomComponent: renderCustomComponent,
    cartItemCustomRenderer: cartItemCustomRenderer,
    cartListCustomRenderer: cartListCustomRenderer
  })), react_1.default.createElement("div", {
    className: "gutter"
  }), react_1.default.createElement("div", {
    className: "side",
    ref: sideElemRef
  }, react_1.default.createElement(CheckoutSummary_1.default, __assign({
    cart: cart,
    disabled: cart.items.length === 0,
    onClick: function onClick(e) {
      if (!user.tmp && !user.data.email) {
        modal.warning({
          title: '尚未驗證信箱',
          content: react_1.default.createElement("div", null, "\u60A8\u597D\uFF0C\u7531\u65BC\u60A8\u5C1A\u672A\u9A57\u8B49\u4FE1\u7BB1", react_1.default.createElement("br", null), "\u6211\u5011\u9700\u8981\u60A8\u7684\u4FE1\u7BB1\u4EE5\u65B9\u4FBF\u5F8C\u7E8C\u670D\u52D9\u3002", react_1.default.createElement("br", null), "\u9EDE\u64CA\u6309\u9215\u6211\u5011\u5C07\u5C0E\u89BD\u60A8\u5230\u4FE1\u7BB1\u9A57\u8B49\u9801\u9762"),
          okText: '點我前往',
          onOk: function onOk() {
            AppActions.navigate(new NavUrl_1.default('/profile'));
          }
        });
        return;
      }
      Tracker_1.default.beginCheckout({
        cart: cart
      });
      AppActions.navigate(NavUrl_1.default.from(NavUrl_1.PredefinedRoute.checkoutInfo));
    },
    prevButtonLabel: AppActions.L('back_products'),
    onPrevClick: function onPrevClick(e) {
      AppActions.navigate(NavUrl_1.default.from(NavUrl_1.PredefinedRoute.products));
    }
  }, checkoutSummaryProps)))), contextHolder);
}
var Wrapper = styled_components_1.default(CheckoutPageWrapper_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.default = CartPage;
var templateObject_1;